import React, { useEffect, useState } from "react";
import { Link, withRouter, useHistory, useParams } from "react-router-dom";

import { useSelector } from "react-redux";
import { registerAttendeeNew, getPreAttendeeByUserId, updateAttendeeNew } from "../../actions/attendeeActions";
import materialize from "materialize-css"
import Localization from "../localization/localization"
import StepWizard from "react-step-wizard";

import { PersonalInformationEstudiante } from "./PersonalInformationEstudiante"
import { getStates, getCities, getCountryByIsoName } from "../../actions/countriesActions";

//import ReactPixel from 'react-facebook-pixel';

const Estudiante2026 = () => {

    const auth = useSelector(state => state.auth);
    const { id } = useParams();

    const [state, updateState] = useState({
        form: {
            nombres: "",
            apellidos: "",
            email: auth.user.email,
            nacimiento: "",
            sexo: "",
            ciudad: "",
            estado: "",
            pais: "MX",
            codigoPostal: "",
            whatsapp: "",
            telefonoCodigoPais:"52",
            propositoVisita: "",
            tipoInstitucion:"",
            carreraEspecialidad:"",
            visita:"",

            notas: "",
            categoria: "ESTUDIANTE",
            tipoRegistro: "pre",
            locale: "es",
        }
    });

  const [disableSubmit, setdisableSubmit] = useState(false);
  const locale = Localization.getLocalizationInstance(localStorage.getItem("exmi_language"));
  const history = useHistory();

  const updateForm = (key, value) => {
    const { form } = state;

    form[key] = value;
    updateState({
      ...state,
      form,
    });

    if (key === "pais") {  
      form["ciudad"] = "";
      updateState({
        ...state,
        form,
      });

      populateStates(value);
      populateCountryPhone(value);

    }

    if (key === "estado") {
      if (form.pais === "MX" || form.pais === "US") {
        populateCities(form.pais, value);
      }
      else {
        form["cities"] = [];
        updateState({
          ...state,
          form,
        });
      }
    }
  };

  const submitForm = () => {

    //e.preventDefault();
    setdisableSubmit(true);
    let language = localStorage.getItem("exmi_language");
    if (language == null)
      language = "es";


    const { user } = auth;

    const newAttendee = {
      userId: user.id,
      nacimiento: state.form.nacimiento,
      sexo: state.form.sexo,
      nombres: state.form.nombres,
      apellidos: state.form.apellidos,
      email: state.form.email,
      celular: state.form.celular,
      whatsapp: state.form.whatsapp,
      telefonoCodigoPais: state.form.telefonoCodigoPais,
      ciudad: state.form.ciudad,
      codigoPostal: state.form.codigoPostal,
      estado: state.form.estado,
      pais: state.form.pais,
      propositoVisita: state.form.propositoVisita,
      tipoInstitucion: state.form.tipoInstitucion,
      carreraEspecialidad: state.form.carreraEspecialidad,
      visita: state.form.visita,
      notas: state.form.notas,

      categoria: state.form.categoria,
      tipoRegistro: state.form.tipoRegistro,
      locale: language,
    }

    //this.props.updateAttendee(this.props.match.params.id, existingAttendee, this.props.history);
  if (id !== undefined && id !== null) {
    updateAttendeeNew(id, newAttendee)
      .then((res) => history.push("/compradorlanding?action=update&id=" + newAttendee.userId))
      .catch((error) => {
        materialize.toast({ html: locale.button_submission_error });
      });
  }
  else {
    registerAttendeeNew(newAttendee)
      .then(res => history.push("/compradorlanding?action=add&id=" + newAttendee.userId))
      .catch(error => {
        setdisableSubmit(false);
        materialize.toast({ html: locale.button_submission_error })
      });
  }
};

  // Do something on step change
  const onStepChange = (stats) => {
    window.scroll(0, 0);
    materialize.AutoInit();
    materialize.updateTextFields();
  };

  const setInstance = SW => updateState({
    ...state,
    SW,
  });

  useEffect(() => {

    const { user } = auth;

    console.log("Loading pre-attendee data for user:", user.id);

    getPreAttendeeByUserId(user.id)
      .then(response => {
        if (response.data !== null) {
          const { form } = state;

          form.nacimiento = response.data.nacimiento;
          form.sexo = response.data.sexo;
          form.nombres = response.data.nombres;
          form.apellidos = response.data.apellidos;
          form.email = response.data.email;
          form.celular = response.data.celular;
          form.telefono = response.data.telefono;
          form.whatsapp = (response.data.whatsapp !== undefined) ? response.data.whatsapp : "";
          form.telefonoCodigoPais = (response.data.telefonoCodigoPais !== undefined) ? response.data.telefonoCodigoPais : "";
          form.ciudad = response.data.ciudad;
          form.codigoPostal = response.data.codigoPostal;
          form.estado = response.data.estado;
          form.pais = response.data.pais;
          form.propositoVisita = response.data.propositoVisita || "";
          form.tipoInstitucion = response.data.tipoInstitucion || "";
          form.carreraEspecialidad = response.data.carreraEspecialidad || "";
          form.visita = response.data.visita || "";


          form.locale = response.data.locale;


          updateState({
            ...state,
            form,
          });
        }
        return response.data;
      })
      .then(res => {
        materialize.AutoInit();
        materialize.updateTextFields();
      })
      .catch(error => console.log(error));

    /*
  materialize.AutoInit();
  materialize.updateTextFields();
  */

    //this.sortChildrenHtmlElementsByParentClass('MotivoAsistenciaParent');
    //this.sortChildrenHtmlElementsByParentClass('ProductosInteresParent');
  }, []);


  const populateCountryPhone = (country) => {

    getCountryByIsoName(country)
      .then(response => {
        const { form } = state;
        form.telefonoCodigoPais = response.data[0].phone_code;
        console.log(response.data[0].phone_code);
        updateState({
          ...state,
          form,
        });
      })
      .catch(err => console.log(err));
  }

  const populateStates = (country) => {
    let states = [];
    getStates(country)
      .then(response => {
        states = response.data[0].states.map((state) => {
          return <option key={state} value={state}>{state}</option>
        });

        const { form } = state;
        form.states = states;
        updateState({
          ...state,
          form,
        });
      })
      .catch(err => console.log(err));
  };

  const populateCities = (country, state_) => {
    let cities = [];
    getCities(country, state_)
      .then(response => {
        console.log(response);
        cities = response.data.map((city) => {
          return <option key={city} value={city}>{city}</option>
        });

        const { form } = state;
        form.cities = cities;
        updateState({
          ...state,
          form,
        });

        materialize.AutoInit();
        materialize.updateTextFields();
      })
      .catch(err => console.log(err));
  };

  return (
    <div>
    <div>
      <div className="col s12 m12 l7 container contentaligned overflowDiv">
          <Link to="/Dashboard" className="btn-flat waves-effect">
            <i className="material-icons left">keyboard_backspace</i> {locale.dashboard_comprador_label_backtohome}
          </Link>
          <StepWizard
            onStepChange={onStepChange}
            //isHashEnabled
            // comment out for default transitions
            instance={setInstance}
          >
            <PersonalInformationEstudiante update={updateForm} locale={locale} form={state.form} submit={submitForm} disableSubmit={disableSubmit}  />
          </StepWizard>
        </div>
      </div>
    </div>
  );
};


export default (withRouter(Estudiante2026));
